import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import i18next from 'i18next';

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import ChecklistUserForm from './checklist_user_form';
import { ChecklistUserService } from '../../services';

@connect(state => {
    return {
      me: state.user.me
    }
  })
class ChecklistUserEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checklistUserId: props.match.params.checklistUserId,
            saved: false,
            submitting: false,
            errorMessage: null,
            localErrorMessage: null,
        }
    }

    componentDidMount() {
        ChecklistUserService.get(this.state.checklistUserId).then((response) => {
            this.setState({checklistUser: response.checklistUser});
        }).catch((err) => {
            this.setState({errorMessage: i18next.t('messages.could-not-load-checklist-user')});
            console.error(err);
        })
    }

    handleLocalError(error) {
      this.setState({localErrorMessage: error});
    }

    handleSubmit(data) {
        this.setState({submitting: true});

        const userToSave = {
            id: this.state.checklistUserId,
            fullName: data.fullName,
            deviceGroupings: data.deviceGroupings.map(grouping => ({'id': grouping.value})),
            enterprise: {'id': this.props.me.enterprise.id}
        }

        ChecklistUserService.save(userToSave).then((response) => {
            this.setState({saved: true, localSuccessMessage: i18next.t('messages.checklist-user-saved')});
        }).catch((err) => {
            this.setState({localErrorMessage: i18next.t('messages.error-saving-checklist-user')});
            console.error(err);
        })
    }

    handleArchive() {
      this.setState({submitting: true});

      ChecklistUserService.archive(this.state.checklistUserId).then((response) => {
        this.setState({saved: true, localSuccessMessage: i18next.t('messages.checklist-user-deleted')});
      }).catch((err) => {
        console.error(err);
        this.setState({errorMessage: i18next.t('messages.error-deleting-checklist-user')});
      })
    }

    messageDismissCallback() {
        this.setState({
          localErrorMessage: null,
          localSuccessMessage: null
        });
      }

    renderMessages() {
        if (this.state.localErrorMessage) {
          return (
              <Message errorMessage={ this.state.localErrorMessage } messageDismissCallback={ this.messageDismissCallback.bind(this) } />
          );
        }
    
        if (this.state.localSuccessMessage) {
          return (
              <Message messages={{ state: { successMessage: this.state.localSuccessMessage } }} messageDismissCallback={ this.messageDismissCallback.bind(this) } />
          );
        }
    
        if (this.props.location.state) {
          return (
              <Message messages={ this.props.location } />
          );
        }
        return null;
      }

    render() {
        if (this.state.errorMessage) {
            return (
                <Redirect to={{
                  pathname: '/config/checklist/users',
                  state: {
                    errorMessage: this.state.errorMessage
                  }
                }}/>
            );
        } else if (this.state.saved) {
            return (
                <Redirect to={{
                  pathname: '/config/checklist/users',
                  state: {
                    successMessage: this.state.localSuccessMessage
                  }
                }}/>
            );
        } else if (!this.state.checklistUser || this.state.submitting) {
            return (
                <div className="loader">{i18next.t('loading')}</div>
            );
        } else {
            const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
            const searchValue = this.props.location.state && this.props.location.state.searchValue ? this.props.location.state.searchValue : null;
            return (
                <div>
                    <div className="row">
                        <PageTitle title={i18next.t('pages.checklist-users.edit-checklist-user')}
                             backLinkWithParams={{
                               link: {
                                  pathname: "/config/checklist/users",
                                  search: backLinkSearch,
                                  state: {
                                    searchValue: searchValue
                                  }
                               }
                             }} />
                    </div>
                    {this.renderMessages()}
                    <div className="op-content-box tree-form">
                        <h4 className="remove-margin-bottom"/>
                            <div className="row">
                                <ChecklistUserForm
                                    checklistUser={this.state.checklistUser}
                                    onSubmit={this.handleSubmit.bind(this)}
                                    onError={this.handleLocalError.bind(this)}
                                    onArchive={this.handleArchive.bind(this)}
                            />
                            </div>
                    </div>
                </div>
            );
        }
    }
}

export default ChecklistUserEdit;